module.exports = __webpack_public_path__ + "img/img02.285b99e9.svg";